var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['el-textarea', _vm.disabled?'is-disabled':'']},[_c('div',{class:[_vm.innerClass, 'el-textarea__inner'],attrs:{"placeholder":_vm.placeholder,"contenteditable":!_vm.disabled},domProps:{"innerHTML":_vm._s(_vm.html)},on:{"input":_vm.input}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bcfab72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/question-editor/components/InputHtml.vue
// module id = 3539
// module chunks = 6